import { useEffect, useRef } from 'react';
export const useProgressSuccess = (isInProgress, hasErrors, onSuccess)=>{
    const prevIsInProgressRef = useRef(isInProgress);
    useEffect(()=>{
        if (prevIsInProgressRef.current !== isInProgress) {
            if (!isInProgress && !hasErrors) {
                onSuccess();
            }
            prevIsInProgressRef.current = isInProgress;
        }
    }, [
        isInProgress
    ]);
};
